import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { authCodeFlowConfig } from './auth.module/auth.config';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthKeycloakService } from './services.module/auth-keycloak.service';
import { ConfigurationApiService } from '../generated/api/configuration/configuration.service';
import { AppModule } from './app.module';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AppModule]
})
export class AppComponent implements OnDestroy {

    /**
     * Für URLs in der folgenden Blacklist, soll keine Keycloak-Login-Prüfung erfolgen
     * TODO in Angular-Guard überführen
     */
    private static readonly ignoredByOAuthServerUrls = [
        '/logout',
        '/registration',
        '/registrierung',
        '/login?uuid', // Nutzeranlage
        '/login?engine', // Puma
        '/login?type=user' // Unternutzeranlage
    ];

    loggedIn = false;

    keycloakError = false;

    private confSubscription: Subscription;

    constructor(
        private readonly oauthService: OAuthService,
        private readonly authKeycloakService: AuthKeycloakService,
        private readonly configurationApiService: ConfigurationApiService
    ) {
        const shouldIgnoreOAuth = AppComponent.ignoredByOAuthServerUrls.find(
            ignoredUrl => window.location.href.includes(ignoredUrl)
        );

        if (shouldIgnoreOAuth) {
            return;
        }

        this.confSubscription = this.configurationApiService.getConfiguration().subscribe({
            next: config => {
                authCodeFlowConfig.issuer = `${config.oauthUrl}/realms/${config.oauthRealmId}`;
                authCodeFlowConfig.clientId = config.oauthClientId;

                this.oauthService.configure(authCodeFlowConfig);
                this.authKeycloakService.setupListeners();
                this.authKeycloakService.attachEvents();
                this.oauthService.setupAutomaticSilentRefresh();

                this.oauthService.loadDiscoveryDocumentAndLogin()
                    .then(result => {
                        // Wenn kein gültiger Login vorhanden, brauchen wir mit den Folgeschritten nicht weiterzumachen
                        if (!result) {
                            console.debug('Kein gültiger Login vorhanden, redirecte zum Keycloak');
                            return;
                        }

                        console.debug('Gültiger Login vorhanden');

                        authKeycloakService.isLoaded = true;
                        authKeycloakService.getUserProfile();
                    })
                    .catch(reason => {
                        console.error('KEYCLOAK ERROR', reason);
                        this.keycloakError = true;
                    });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.confSubscription) {
            this.confSubscription.unsubscribe();
        }
    }

}
